import axios from 'axios'
import { environment } from '@/data/environment/'
import {commit} from "lodash/seq";

export default {
  namespaced: true,
  state: {
    statusResponse: false,
    updateStatusResponse: false,
    updateAppTypesResponse: false,
    updateClientResponse: false,
    listClients: [],
    appTypes: [],
  },
  mutations: {

    setListClients (state, data) {
      state.listClients = data
    },
    setAppTypes (state, data) {
      state.appTypes = data
    },
    setResponseClient (state, data) {
      state.statusResponse = data
    },
    setUpdateResponseClient (state, data) {
      state.updateStatusResponse = data
    },
    setUpdateAppTypesResponse(state, data)  {
      state.updateAppTypesResponse = data
    },
    setUpdateClientResponse(state, data) {
      state.updateClientResponse = data
    }
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getAppTypes ({ commit }) {
      const endpoint = '/getAppTypes'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setAppTypes', response.data.Mensaje)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    updateAppTypes({ commit }, data) {
      const endpoint = '/updateAppTypes'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .put(url, data)
        .then(response => {
          if (response.data.Mensaje) {
            commit('setUpdateAppTypesResponse', response.data.Mensaje)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertClients ({ commit }, data) {
      const endpoint = '/add-compania'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      return axios
        .create()
        .post(url, data)
        .then(response => {
          if (!response.data.respuesta.Error) {
              commit('setResponseClient', true);
          }else{
            console.log(response.data);
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    activeInactiveClient ({ commit }, data) {
      const endpoint = '/updateStatusClient'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .post(url, data)
        .then(response => {
          if (response.data.Mensaje) {
            commit('setUpdateResponseClient', response.data.Mensaje)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    setStatusResponse ({ commit }, data) {
      commit('setResponseClient', data)
    },
    setUpdateResponseClient ({ commit }, data) {
      commit('setUpdateResponseClient', data)
    },
    setUpdateAppTypesResponse({ commit }, data) {
      commit('setUpdateAppTypesResponse', data)
    },
    updateClient ({ commit }, data) {
      const endpoint = '/updateClient'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .put(url, data)
        .then(response => {
          const responseData = response.data

          if (responseData.Mensaje) {
            commit('setUpdateClientResponse', responseData.Mensaje)
          }
          return responseData
        })
        .catch(function (error) {
          if (error.response) {
            const mensaje = error.response.data?.Mensaje || 'Error al actualizar cliente'
            throw new Error(mensaje)
          }
          throw error
        })
    },
    setUpdateClientResponse({ commit }, data) {
      commit('setUpdateClientResponse', data)
    }
  },
}
